import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";

import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import * as ROUTES from "../../constants/routes";
import { withFirebase } from "../Firebase";
import { LoadingPage } from "../LoadingPage";
import { useTranslation } from "react-i18next";
import { red } from "@material-ui/core/colors";

export const Finish = (props) => {
  const { t } = useTranslation();
  let history = useHistory();
  const { id, evaluationId, firebase } = props;
  const [isAproved, setisAproved] = useState(true);
  const [isLoaded, setisLoaded] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  useEffect(() => {
    /**
     * Se encesita comprobar que el usuario no tiene la evaluación aprovada para que no pueda acceder en tal caso
     */
    firebase
      .evaluationMetadata(firebase.currentUser().uid, evaluationId)
      .once("value")
      .then((snap) => {
        setisAproved(snap.val().evalApproved);
        setisLoaded(true);
        if (snap.val().evalApproved) {
          history.push(ROUTES.MODULE.replace(":id", id));
        }
      });
  }, []);

  return (
    <>
      <Dialog open={!confirmationModalOpen}>
        <DialogTitle>
          <Typography variant="h6" color="primary">
            {t("formationEnd")}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{t("formationEndText")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => history.push(ROUTES.MODULE.replace(":id", id))}>
            {t("home")}
          </Button>
          {isLoaded ? (
            <Button
              color="secondary"
              variant="contained"
              // disabled={isAproved}
              onClick={() => {
                !isAproved ? history.push(`/evaluation/${evaluationId}`) : setConfirmationModalOpen(true);
              }}
            >
              {t("gotoEvaluation")}
            </Button>
          ) : (
            <CircularProgress color={"secondary"} style={{ marginRight: 45, marginLeft: 45 }} />
          )}
        </DialogActions>
      </Dialog>

      <Dialog open={confirmationModalOpen}>
        <DialogTitle id="alert-dialog-title">{t("newEvaluationConfirmTitle")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("newEvaluationConfirmText")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => history.push(ROUTES.HOME)} style={{ color: red[600] }}>
            {t("declineNewEvaluation")}
          </Button>
          <Button
            onClick={() => {
              setConfirmationModalOpen(false);
              history.push(`/evaluation/${evaluationId}`);
              //firebase.userReport(uid).child();
              /*history.push(
             `/evaluation/result/${attempNumber}/${data.id}/${uid}`
           );*/
            }}
            color="primary"
            variant="contained"
            autoFocus
          >
            {t("startNewEvaluation")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withFirebase(Finish);
